/**
 * Assistant identity and remaining FE-side prompt fragments for the focused
 * view's AI layer. The assistant name maps to a server-side route; the system
 * prompt and end-of-call summary instruction now live on the BE (CoachAgent
 * starter prompt + CoachPostCallSummaryAction handler).
 */

export const COACH_ASSISTANT_NAME = 'SalesLiveCoachingAssistant';

/**
 * Header attached to each live-suggestion stream so the BE-side coach agent
 * can distinguish a tactical in-the-moment suggestion request from any other
 * user-content message. The contract is owned jointly with the BE agent's
 * starter prompt.
 */
export const LIVE_SUGGESTION_PROMPT_HEADER = `LIVE COACHING REQUEST

The call is in progress. Below are the latest transcript lines. Give me ONE short, tactical, in-the-moment coaching suggestion for what the rep should say or do next. Do NOT summarize the call.`;
